import clsx from 'clsx'
import type { PropsWithChildren } from 'react'

interface RequestItemProps extends PropsWithChildren {
  label: string
  value?: string
  muted?: boolean
}

export const RequestItem = ({
  label,
  value,
  muted,
  children
}: RequestItemProps) => {
  return (
    <div className="flex items-center gap-2">
      <p className="font-medium whitespace-nowrap">{label}:</p>
      <span className={clsx({ 'text-foreground/50': muted })}>{value}</span>
      {children}
    </div>
  )
}
